import WIcons from './w-icon';
class IconFavorites extends WIcons {
    contents = `
        <path 
            id="Path_23"
            data-name="Path 23"
            d="M688.1,420.554l-8.227-8.227a4.585,4.585,0,0,1,6.484-6.484l1.743,1.743,1.743-1.743a4.585,4.585,0,0,1,6.484,6.484Z"
            transform="translate(-678.525 -404.5)" fill="currentColor" 
        />`;
}
customElements.define( 'icon-favorites', IconFavorites );